export class MessageClose {
    constructor(optionalOptions = {}) {
        this._frames = document.querySelectorAll('.chat--chat-message--frame');

        if (!this._frames) {
            this.destructor();
            return true;
        }

        for (let i = 0; i < this._frames.length; ++i) {
            let frame = this._frames[i];
            this._close = frame.querySelector('.chat--chat-message--close');
            if (this._close) {
                this._close.addEventListener("click", (event) => {
                    event.preventDefault()

                    frame.classList.remove('show');
                })
            }
        }
    }

    destructor() {
        this._close = null;
        this._frames = null;
    }
}

export default new MessageClose();